import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IInboxRowProps } from './IInboxRowProps';
import { inboxTone } from './inboxTone';
import { useInboxText } from './useInboxText';

/**
 * Рядок «Моїх вхідних» (прототип v4 G:L2575): кружок 30px кольору виду зі знаком («A», «!», «“», «i»), вид 11px 700 великими літерами
 * в тоні й робочий простір 12px; текст (600 — непрочитане, клік відкриває запис), підпис 12px («Строк …», «коли»), кнопки «Відкрити» і
 * «Позначити прочитаним / непрочитаним». Непрочитаний рядок — тло color-mix(--accent-soft 45%, --surface).
 */
export function InboxRow({ entry, workspaceName, onOpen, onToggle }: IInboxRowProps) {
  const { t } = useTranslation();
  const textOf = useInboxText();
  const { tone, glyph } = inboxTone(entry);
  const { text, meta } = textOf(entry);
  return (
    <div className={cx('ib-row', !entry.read && 'is-unread')}>
      <span className="ib-glyph" style={{ background: tone }} aria-hidden="true">{glyph}</span>
      <div className="ib-row__body">
        <div className="ib-row__top">
          <span className="ib-kind" style={{ color: tone }}>{t(`inboxPage.kinds.${entry.kind}`)}</span>
          <span className="ib-where">{workspaceName}</span>
        </div>
        <button type="button" className="ib-text" onClick={() => onOpen(entry)}>{text}</button>
        <span className="ib-meta">{meta}</span>
        <div className="ib-actions">
          <button type="button" className="ib-btn" onClick={() => onOpen(entry)}>{t('inboxPage.open')}</button>
          <button type="button" className="ib-btn" onClick={() => onToggle(entry)}>{entry.read ? t('inboxPage.markUnread') : t('inboxPage.markRead')}</button>
        </div>
      </div>
    </div>
  );
}
